import { useEffect, useState } from 'react';
import { ru } from '../../data/ru';
import { by } from '../../data/by';
import {TEST_CREATOR_CREATOR_URL} from "../../../config";

export default function HeaderTest({ addHeaderTest,name='',description='',exame_time=0 }) {
  let language = localStorage.getItem('lang') === 'ru' ? ru.RoleIdThree : by.RoleIdThree;const [state, setState] = useState({
    name: '',
    // is_anket: false,
    description: '',
    exame_time: 0,
  });

  useEffect(() => {
    addHeaderTest(state);
  }, [state]);
  useEffect(()=>{
    setState({   name: name,
      // is_anket: false,
      description: description,
      exame_time: exame_time/60,})
  },[name,description,exame_time])

  function changeHandler(e) {
    const name = e.target.name;
    const value =
        e.target.type === 'radio'
            ? e.target.value === 'true'
            : e.target.type === 'number'
            ? e.target.value < 0
                ? -e.target.value
                : e.target.value
            : e.target.value;

    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }
  return (
    <div className='test-creator-header-block'>
      <div className='test-creator-test-element'>
        <p>{language.createTestNameOfTheTest}</p>
        <input value={state.name} name="name" type="text" onChange={(e) => changeHandler(e)}/>
      </div>
      <div className='test-creator-test-element'>
        <p>{language.createTestDescriptionTest}</p>
        <input value={state.description} name="description" type="text" onChange={(e) => changeHandler(e)}/>
      </div>
      {/* <div className='test-creator-choice'>
      <label><input name="is_anket" value={true} checked={state.is_anket === true} type="radio" onChange={(e) => changeHandler(e)} /> {language.createTestQuestionnaire}</label>
      <label><input name="is_anket" value={false} checked={state.is_anket === false} type="radio" onChange={(e) => changeHandler(e)} /> {language.createTestTest}</label>
      </div> */}
      {window.location.pathname.includes(TEST_CREATOR_CREATOR_URL) && <div className='test-creator-test-element-1'>
        <p>{language.createTestCompletionTime}</p>
        <input
            value={state.exame_time}
            name="exame_time"
            type="number"
            pattern="[0-9]{5}"
            onChange={(e) => {
              changeHandler(e)
            }}
            className="test-creator-header-block-input"/>
      </div>}
    </div>
  )
}